import { render } from "./ToTop.vue?vue&type=template&id=b4e8fb80&scoped=true"
import script from "./ToTop.vue?vue&type=script&lang=js"
export * from "./ToTop.vue?vue&type=script&lang=js"

import "./ToTop.vue?vue&type=style&index=0&id=b4e8fb80&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e8fb80"]])

export default __exports__